import { readonly, ref } from 'vue';

export const DEFAULT_THEME = 'frontier-terminal' as const;
export const THEME_STORAGE_KEY = 'tw3002.theme.v1';

export const THEMES = [
  { id: 'frontier-terminal', name: 'Frontier Terminal' },
  { id: 'stardock-command', name: 'StarDock Command' },
] as const;

export type ThemeId = (typeof THEMES)[number]['id'];

const selectedTheme = ref<ThemeId>(DEFAULT_THEME);

export const themeId = readonly(selectedTheme);

export function isThemeId(value: unknown): value is ThemeId {
  return THEMES.some(theme => theme.id === value);
}

function readStoredTheme(): ThemeId | null {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return isThemeId(stored) ? stored : null;
  } catch {
    return null;
  }
}

function applyTheme(theme: ThemeId) {
  document.documentElement.dataset.theme = theme;
  selectedTheme.value = theme;
}

export function initializeTheme() {
  const rootTheme = document.documentElement.dataset.theme;
  applyTheme(readStoredTheme() ?? (isThemeId(rootTheme) ? rootTheme : DEFAULT_THEME));
}

export function setTheme(theme: ThemeId) {
  if (!isThemeId(theme)) return;

  applyTheme(theme);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // A blocked storage area should not prevent a visual preference change.
  }
}
